// @flow
/** @jsx jsx */

import { merge } from 'lodash';

import { Colors } from '@zapier/theme';
import { jsx } from '@emotion/core';

import FacebookIcon from './FacebookIcon';
import SSOButton, { getStartUrlForProvider } from '../SSOButton';
import { defaultSSOButtonCSS } from '../../constants';

import type { FacebookSSOButtonProps as Props } from '../../types';

// The constants below are from Facebook Guidelines
const FACEBOOK_BLUE = '#3b5999';
const FACEBOOK_BOX_SHADOW =
  '0 0 1px rgba(#000, 0.12), 0 1px 1px rgba(#000, 0.24)';

const labelCss = {
  flex: 1,
  marginLeft: '-2rem', // compensate the logo to look like centered
  textAlign: 'center',
};

const defaultCss = merge(defaultSSOButtonCSS, {
  backgroundColor: FACEBOOK_BLUE,
  border: 'none',
  boxShadow: FACEBOOK_BOX_SHADOW,
  color: Colors.white,
  ':hover,:focus': {
    backgroundColor: FACEBOOK_BLUE,
    color: Colors.white,
  },
});

const href = getStartUrlForProvider('facebook');

const FacebookSSOButton = ({ label, ...props }: Props) => {
  return (
    <SSOButton href={href} {...props}>
      <span css={defaultCss}>
        <FacebookIcon />
        <span css={labelCss}>{label}</span>
      </span>
    </SSOButton>
  );
};

FacebookSSOButton.defaultProps = {
  label: 'Continue with Facebook',
};

export default FacebookSSOButton;
